import { render, staticRenderFns } from "./WorkActionsBuy.vue?vue&type=template&id=07c7b3db&scoped=true&"
import script from "./WorkActionsBuy.vue?vue&type=script&lang=js&"
export * from "./WorkActionsBuy.vue?vue&type=script&lang=js&"
import style0 from "./WorkActionsBuy.vue?vue&type=style&index=0&id=07c7b3db&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c7b3db",
  null
  
)

export default component.exports